/*
	This is a file that ONLY HOUSES ANALYTICS calls.
*/
import { useEffect } from "react";
import { markExperiments } from "shared/util/Experiment";
import * as Sentry from "@sentry/browser";
import Analytics from "./util/Analytics";
import get from "lodash/get";

const USER_TYPES = {
	EXISTING: "existing user",
	NEW: "new user",
};

const ATTEMPT_TYPES = {
	SUCCESS: "success",
	INVALID_CODE: "invalid code",
	FAILED_REQUEST: "failed request",
};

export const BUTTON_TYPES = {
	ADD: "add",
	EDIT: "edit",
};

const INVALID_OTP_ATTEMPT_CODE = 13;

export const isInvalidOtpCodeError = (errors) => {
	const code = get(errors, ["graphQLErrors", 0, "extensions", "code"]);
	return code === INVALID_OTP_ATTEMPT_CODE;
};

// tracking documented here:
// https://confluence.dev.okcupid.com/display/AN/SMS

// track when a user successfully entered a valid phone number
// and selected the "Next" or "Continue" button. And the API call succeeded.
export const trackSmsCodeSent = ({
	existingUser,
	countryCode,
}) => {
	const data = {
		"phone country code": countryCode,
		"user type": existingUser ? USER_TYPES.EXISTING : USER_TYPES.NEW,
	};
	Analytics.logUIEvent(Analytics.eventNames.smsCodeSentSuccess, { data });
};

export const trackSmsCodeReSent = () =>
	Analytics.logUIEvent(Analytics.eventNames.smsSelectedResendCode);

export const trackSmsCodeVertificationResponse = ({
	existingUser,
	error,
	success,
}) => {
	let outcome;

	const invalidCode = error && isInvalidOtpCodeError(error);

	if (success) {
		outcome = ATTEMPT_TYPES.SUCCESS;
	} else if (invalidCode) {
		outcome = ATTEMPT_TYPES.INVALID_CODE;
	} else {
		outcome = ATTEMPT_TYPES.FAILED_REQUEST;
	}

	const data = {
		"user type": existingUser ? USER_TYPES.EXISTING : USER_TYPES.NEW,
		"attempt type": outcome,
	};
	Analytics.logUIEvent(Analytics.eventNames.smsCodeVertificationResponse, { data });
};

export const trackSmsAddOrEditButtonClick = (addOrEdit) => {
	const data = { "button type": addOrEdit };
	Analytics.logUIEvent(Analytics.eventNames.smsSelectedEditPhoneButton, { data });
};

export const selectedSettingsSection = (section) => {
	const data = { "section type": section };
	Analytics.logUIEvent(Analytics.eventNames.selectedSettingsSection, { data });
};

export const trackShowPhoneWall = () => {
	Analytics.logUIEvent(Analytics.eventNames.smsWallShown);
};

export const useMarkSmsForcedMigration = () =>
	useEffect(() => {
		markExperiments(["SMS_FORCED_MIGRATION"]).catch(Sentry.captureException);
	}, []);



// WEBPACK FOOTER //
// ./src/analytics/sms.js